import React from 'react';

import DataTableConfigSelector from 'notebook/data-tables/DataTableConfigSelector';
import {MODEL_NAMES} from 'results/ResultsNamingConstants';
import {ButtonStyle} from 'ui-library/buttons/Button';
import ErrorMessage from 'ui-library/ErrorMessage';
import Modal from 'ui-library/modals/Modal';

interface LegacyDataTableInsertModalProps {
  fileId: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onInsertDataTableConfig: ({dataTableConfig, cidIdMap}: any) => void;
  onRequestClose: () => void;

  type: string;
}
interface State {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  dataTableConfig: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  cidIdMap: any;
  error: string | null;
}

interface DataTableConfigSelectorSelection {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  dataTableConfig: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  cidIdMap: any;
  error: string | null;
}

/**
 * A React component that renders a modal for inserting a new data table or data table config component.
 *
 * @deprecated This table is no longer supported, please do not further proliferate its use.
 */
export default class LegacyDataTableInsertModal extends React.Component<
  LegacyDataTableInsertModalProps,
  State
> {
  state: State = {
    dataTableConfig: null,
    cidIdMap: null,
    error: null,
  };

  handleInsertClick: () => void = () => {
    const {dataTableConfig, cidIdMap} = this.state;
    this.props.onInsertDataTableConfig({dataTableConfig, cidIdMap});
  };

  _handleDataTableConfigChange: (newSelection: DataTableConfigSelectorSelection) => void = ({
    dataTableConfig,
    cidIdMap,
    error,
  }) => {
    this.setState({dataTableConfig, cidIdMap, error});
  };

  render(): JSX.Element {
    return (
      <Modal
        title={`Insert ${MODEL_NAMES.result_table}`}
        onRequestClose={this.props.onRequestClose}
        onRequestSubmit={this.handleInsertClick}
        className="mediocre" // TableEditable's CSS is namespaced under mediocre
        buttons={[
          {
            text: 'Insert',
            submit: true,
            style: ButtonStyle.SECONDARY,
            disabled: this.state.dataTableConfig == null || this.state.error != null,
          },
        ]}
      >
        <DataTableConfigSelector
          fileId={this.props.fileId}
          type={this.props.type}
          onDataTableConfigChange={this._handleDataTableConfigChange}
          selectedDataTableConfig={this.state.dataTableConfig}
        />
        {this.state.error && <ErrorMessage error={this.state.error} />}
      </Modal>
    );
  }
}
